import {useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";

/**
 * @param useEnglishNotation - if true, the number will be formatted in English notation (e.g. 1.2k). In other languages (such as German) the number 1200 will not be formatted as 1.2k, hence the default
 */
const useSocialNumberFormat = (useEnglishNotation: boolean = true, useCompactNotation: boolean = true) => {
  const {i18n} = useTranslation();
  const formatter = useMemo(
    () =>
      Intl.NumberFormat(useEnglishNotation ? "en" : i18n.language, {
        notation: useCompactNotation ? "compact" : undefined,
      }),
    [i18n.language, useEnglishNotation],
  );
  const format = useCallback((value: number | null | undefined) => formatter.format(value || 0), [formatter]);

  return format;
};

export {useSocialNumberFormat};
